<template>
    <img src="/favicon.png" alt="Призрачная полка">
</template>
